<template>
  <div class="router-builder-pop-out-map">
    <RouteBuilderMap
      :proposed-shipments="proposedShipments"
      :mileages="mileages"
      :highlighted-shipment-identifiers="highlightedShipmentIdentifiers"
      show-pop-in-button
      @pop-in="onPopIn"
    />
  </div>
</template>

<script lang="ts" setup>
import { useEventListener } from '@vueuse/core';
import type { Ref } from 'vue';
import { onMounted, ref } from 'vue';

import { Mileages } from '@/composables/routeBuilder';
import { ProposedShipment } from '@/model/routeBuilder';
import {
  ChildMessage,
  ParentMessage,
} from '@/model/routeBuilder/map/messaging';
import { RoutePlanProposedShipment } from '@/model/routeBuilder/phase2';

import RouteBuilderMap from '@/components/routeBuilder/RouteBuilderMap.vue';

useEventListener('message', ({ data }: MessageEvent<ParentMessage>) => {
  if (data.type === 'init') {
    proposedShipments.value = parseShipmentsFromMessage(data.proposedShipments);
    mileages.value = data.mileages;
    highlightedShipmentIdentifiers.value = data.highlightedShipmentIdentifiers;
  } else if (data.type === 'update:shipments') {
    proposedShipments.value = parseShipmentsFromMessage(data.proposedShipments);
  } else if (data.type === 'update:mileages') {
    mileages.value = data.mileages;
  } else if (data.type === 'update:highlights') {
    highlightedShipmentIdentifiers.value = data.highlightedShipmentIdentifiers;
  }
});

const proposedShipments: Ref<ProposedShipment[] | RoutePlanProposedShipment[]> =
  ref([]);
const mileages: Ref<Mileages> = ref({});
const highlightedShipmentIdentifiers: Ref<
  Array<RoutePlanProposedShipment['identifier']>
> = ref([]);

const onPopIn = () => {
  const msg: ChildMessage = { type: 'close' };
  window.opener.postMessage(msg);
};

const parseShipmentsFromMessage = (
  proposedShipments: ProposedShipment[] | RoutePlanProposedShipment[],
): ProposedShipment[] | RoutePlanProposedShipment[] => {
  if (
    RoutePlanProposedShipment.isRoutePlanProposedShipment(proposedShipments[0])
  ) {
    const incomingShipments = proposedShipments as RoutePlanProposedShipment[];
    return incomingShipments.map((s) => new RoutePlanProposedShipment(s));
  } else {
    const incomingShipments = proposedShipments as ProposedShipment[];
    return incomingShipments.map((s) => new ProposedShipment(s));
  }
};

onMounted(() => {
  const msg: ChildMessage = { type: 'ready' };
  window.opener.postMessage(msg);
});
</script>

<style>
.router-builder-pop-out-map {
  --p-button-text-primary-color: var(--content-header-dark-bg-color);
  --p-button-text-primary-hover-background: var(
    --content-header-dark-bg-hover-background
  );
}
</style>
